export var ExpenseTypes;
(function (ExpenseTypes) {
    ExpenseTypes["LivingExpensesEstimate"] = "LIVING_EXPENSES_ESTIMATE";
    ExpenseTypes["Groceries"] = "GROCERIES";
    ExpenseTypes["Childcare"] = "CHILDCARE";
    ExpenseTypes["ChildAndSpousalMaintenance"] = "CHILD_AND_SPOUSAL_MAINTENANCE";
    ExpenseTypes["PrimarySecondaryEducation"] = "PRIMARY_SECONDARY_EDUCATION";
    ExpenseTypes["HigherVocationalTrainingEducation"] = "HIGHER_VOCATIONAL_TRAINING_EDUCATION";
    ExpenseTypes["PrivateSchoolingAndTuition"] = "PRIVATE_SCHOOLING_AND_TUITION";
    ExpenseTypes["ClothingAndPersonalCare"] = "CLOTHING_AND_PERSONAL_CARE";
    ExpenseTypes["RecreationAndEntertainment"] = "RECREATION_AND_ENTERTAINMENT";
    ExpenseTypes["TelephoneInternetPayTvAndMediaStreamingSubscriptions"] = "TELEPHONE_INTERNET_PAY_TV_AND_MEDIA_STREAMING_SUBSCRIPTIONS";
    ExpenseTypes["PetCare"] = "PET_CARE";
    ExpenseTypes["Transport"] = "TRANSPORT";
    ExpenseTypes["BodyCorporateFeesStrataFeesAndLandTax"] = "BODY_CORPORATE_FEES_STRATA_FEES_AND_LAND_TAX";
    ExpenseTypes["PrimaryResidenceRunningCosts"] = "PRIMARY_RESIDENCE_RUNNING_COSTS";
    ExpenseTypes["InvestmentPropertyRunningCosts"] = "INVESTMENT_PROPERTY_RUNNING_COSTS";
    ExpenseTypes["SecondaryResidenceRunningCosts"] = "SECONDARY_RESIDENCE_RUNNING_COSTS";
    ExpenseTypes["Insurance"] = "INSURANCE";
    ExpenseTypes["LifeInsurance"] = "LIFE_INSURANCE";
    ExpenseTypes["HealthInsurance"] = "HEALTH_INSURANCE";
    ExpenseTypes["MedicalAndHealth"] = "MEDICAL_AND_HEALTH";
    ExpenseTypes["Rent"] = "RENT";
    ExpenseTypes["Board"] = "BOARD";
    ExpenseTypes["Other"] = "OTHER";
})(ExpenseTypes || (ExpenseTypes = {}));
//# sourceMappingURL=ExpenseTypes.js.map